import React from 'react';
import { Modal } from 'antd';
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'react-i18next';
import { Note } from '@/types/releaseNote';
import useLanguageStore from '@/stores/useLanguageStore';

export interface ReleaseNotesPopupProps {
  visible: boolean;

  note: Note;

  onClose: () => void;
}

/**
 * Displays the current release note in a modal popup.
 */
export const ReleaseNotesPopup: React.FC<ReleaseNotesPopupProps> = ({ visible, note, onClose }) => {
  const { t } = useTranslation();
  const { language } = useLanguageStore();

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={[
        <button
          key='close'
          type='button'
          className='h-9 px-5 rounded-lg bg-[rgb(237,224,74)] text-[rgb(57,57,60)] text-[13px] font-semibold cursor-pointer hover:bg-[rgb(230,217,60)] transition-colors'
          onClick={onClose}
        >
          {t('close')}
        </button>,
      ]}
      title={t('whats_new')}
      centered
      destroyOnClose
      width={600}
    >
      <div className='mt-2'>
        {note ? (
          <ReactMarkdown>{note[language]}</ReactMarkdown>
        ) : (
          <p>{t('no_release_notes_available')}</p>
        )}
      </div>
    </Modal>
  );
};

export default ReleaseNotesPopup;
